import React from "react";

// Canonical disclaimer text (single source of truth for the frontend).
export const DISCLAIMER_TEXT =
  "ForecastNest provides AI-generated market analysis and quantitative research " +
  "for informational and educational purposes only. Nothing here constitutes " +
  "financial, investment, legal, or tax advice. Conduct your own research and " +
  "consult a licensed financial advisor before making investment decisions.";

// Sitewide legal disclaimer establishing ForecastNest's positioning as a
// research/informational platform (not an investment advisor). Render in
// footers, on the sign-in screens, and wherever money is asked for.
// `textClass` lets dark backgrounds override the default muted color.
const ResearchDisclaimer = ({ className = "", textClass = "text-muted" }) => (
  <p className={`${textClass} fs-11 mb-0 ${className}`}>{DISCLAIMER_TEXT}</p>
);

export default ResearchDisclaimer;
